import { OrderTrackingSummary } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'order';

/**
 * This controller is used for all of the 'unauthenticated' order tracking link
 * endpoints. This will bypass the authentication middleware, instead relying on
 * the access token provided in the request to authenticate the user.
 *
 * Authenticated endpoints are handled by the OrderTrackingLinkController.
 */
export class OrderTrackingLinkUnauthenticatedController extends BaseHttpController {
  constructor() {
    super(endpoint, { bypassAuthInterceptor: true });
  }

  async getOrderTrackingSummary(
    orderId: number,
    accessToken: string,
  ): Promise<OrderTrackingSummary> {
    const response = await this.http.get<OrderTrackingSummary>(
      `/${orderId}/tracking-link/tracking`,
      { params: { accessToken } },
    );
    return new OrderTrackingSummary(response.data);
  }
}
